<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,2C13,2,6,2,6,2C5.45,2,5,2.45,5,3C5,3.55,5.45,4,6,4C6,4,10.59,4,10.59,4C10.59,4,2.3,12.29,2.3,12.29C2.11,12.47,2,12.72,2,13C2,13.55,2.45,14,3,14C3.2800000000000002,14,3.5300000000000002,13.89,3.71,13.71C3.71,13.71,12,5.41,12,5.41C12,5.41,12,10,12,10C12,10.55,12.45,11,13,11C13.55,11,14,10.55,14,10C14,10,14,3,14,3C14,2.45,13.55,2,13,2C13,2,13,2,13,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ArrowTopRight',
} as DefineComponent
</script>
